import React from 'react'
import PropTypes from 'prop-types'
import {
  IconFAWrapper,
  ICON_FA_VARIANT_SOLID,
  ICON_FA_VARIANT_REGULAR,
  ICON_FA_VARIANT_LIGHT
} from './IconFAWrapper'

export const IconFACheckCircle = ({
  className,
  variant,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconFAWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      {variant === ICON_FA_VARIANT_SOLID ? (
        <svg
          aria-hidden='true'
          focusable='false'
          data-prefix='fas'
          data-icon='check-circle'
          role='img'
          viewBox='0 0 512 512'
        >
          <path
            shapeRendering='geometricPrecision'
            fill='currentColor'
            d='M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z'
          />
        </svg>
      ) : variant === ICON_FA_VARIANT_REGULAR ? (
        <svg
          aria-hidden='true'
          focusable='false'
          data-prefix='far'
          data-icon='check-circle'
          role='img'
          viewBox='0 0 512 512'
        >
          <path
            shapeRendering='geometricPrecision'
            fill='currentColor'
            d='M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z'
          />
        </svg>
      ) : (
        <svg
          aria-hidden='true'
          focusable='false'
          data-prefix='fal'
          data-icon='check-circle'
          role='img'
          viewBox='0 0 512 512'
        >
          <path
            shapeRendering='geometricPrecision'
            fill='currentColor'
            d='M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 464c-118.664 0-216-96.055-216-216 0-118.663 96.055-216 216-216 118.664 0 216 96.055 216 216 0 118.663-96.055 216-216 216zm141.63-274.961L217.15 376.071c-4.705 4.667-12.303 4.637-16.97-.068l-85.878-86.572c-4.667-4.705-4.637-12.303.068-16.97l8.52-8.451c4.705-4.667 12.303-4.637 16.97.068l68.976 69.533 163.441-162.13c4.705-4.667 12.303-4.637 16.97.068l8.451 8.52c4.668 4.705 4.637 12.303-.068 16.97z'
          />
        </svg>
      )}
    </IconFAWrapper>
  )
}

IconFACheckCircle.defaultProps = {
  variant: ICON_FA_VARIANT_REGULAR
}

IconFACheckCircle.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.oneOf([
    ICON_FA_VARIANT_SOLID,
    ICON_FA_VARIANT_REGULAR,
    ICON_FA_VARIANT_LIGHT
  ]),
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
